module.exports = __webpack_public_path__ + "img/lock.41c78d9b.svg";